import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { useToggle } from '../../../hooks';
import { post, put, destroy, isBDCLoggedIn } from '../../../utils/DeApi';
import ErrorHandler from '../../ErrorHandler/ErrorHandler';

const FormTypeModal = ({
  mode = "Add",
  formType = {},
  onClose = () => null,
  show = false,
}) => {
  const [name, setName] = useState(formType?.name || '');
  const [isSubmitting, toggleIsSubmitting] = useToggle(false);
  const [error, setError] = useState(null);
  const subscribedPromises = useRef([]);

  useEffect(() => {
    if(formType?.name) {
      setName(formType?.name);
    }
  }, [formType]);

  useEffect(() => {
    const promises = subscribedPromises.current;
    return () => {
      promises.forEach((cancel) => cancel());
    }
  }, []);

  if (mode === "Delete") {
    return (
      <DeleteFormTypeContent
        show={show}
        formType={formType}
        onClose={onClose}
      />
    )
  }
  const handleSubmit = (event) => {
    event.preventDefault();
    toggleIsSubmitting();
    const { promise, cancel } = mode === 'Add' 
    ? post('formtypes', { name: name, isBdc: (isBDCLoggedIn() ? "yes" : "no") })
    : put('formtypes/' + formType?.id, { name: name, isBdc: (isBDCLoggedIn() ? "yes" : "no") });

    promise
    .then((response) => {
      setName('');
      onClose(response.data, mode);
    })
    .catch((error) => setError(error))
    .finally(toggleIsSubmitting);
    subscribedPromises.current.push(cancel);
  }

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{mode} Form Type</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Form Type Name"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </Form.Group>
          <Button
            type="submit"
            className="float-right btn btn-success-deal-style roundedEdges"
            disabled={isSubmitting}
          >
            {isSubmitting && (
              <Spinner
                as="span"
                animation="border"
                variant="light"
                size="sm"
                className="m-1"
              />
            )}
            {mode}
          </Button>
        </Form>
        {error && <ErrorHandler error={error} />}
      </Modal.Body>
    </Modal>
  );
}

const DeleteFormTypeContent = ({formType, show, onClose}) => {
  const [isSubmitting, toggleIsSubmitting] = useToggle(false);
  const [error, setError] = useState(null);
  const subscribedPromises = useRef([]);

  const handleDelete = () => {
    toggleIsSubmitting();
    const { promise, cancel } = destroy('formtypes/' + formType?.id);
    promise
    .then((response) => onClose(formType))
    .catch((error) => setError(error))
    .finally(toggleIsSubmitting);
    subscribedPromises.current.push(cancel);
  }

  useEffect(() => {
    const promises = subscribedPromises.current;

    return () => promises.forEach((cancel) => cancel())
  }, []);
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Body>
        Are you sure you want to delete the form type <span className="font-weight-bold">{formType?.name}</span>?
        {error && <ErrorHandler error={error} />}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="danger"
          className='roundedEdges'
          onClick={handleDelete}
          disabled={isSubmitting}
        >
          {isSubmitting && (
            <Spinner
              as="span"
              animation="border"
              variant="light"
              size="sm"
              className="m-1"
            />
          )}
          Yes, Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default FormTypeModal;
